export default function OnboardingProgress({
  step = 1,
  totalSteps = 5,
}: {
  step?: number;
  totalSteps?: number;
}) {
  const steps = Array.from({ length: totalSteps }, (_, i) => i + 1);
  return (
    <div className="px-4 pt-12 pb-8">
      <div className="max-w-md mx-auto w-full">
        <div className="relative">
          <div className="absolute left-0 top-1/2 -mt-px w-full h-0.5 bg-gray-200 dark:bg-gray-700/60" aria-hidden="true"></div>
          <ul className="relative flex justify-between w-full">
            {steps.map((n) => (
              <li key={n}>
                <span className={`cursor-default flex items-center justify-center w-6 h-6 rounded-full text-xs font-semibold ${step >= n ? 'bg-cream-500 text-white' : 'bg-white dark:bg-gray-900 text-gray-500 dark:text-gray-400'}`}>{n}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}
